import React from 'react';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import RoutesComponent from './app';
import { Toaster } from './components/ui/sonner';
import './index.css';

const CLIENT_BASE_PATH = process.env.CLIENT_BASE_PATH || '/';

const MainApp = () => {
  return (
    <BrowserRouter basename={CLIENT_BASE_PATH}>
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => (
          <div className="flex min-h-screen items-center justify-center bg-background p-6">
            <div className="max-w-md rounded-lg border bg-card p-6 text-center shadow-sm">
              <h1 className="text-lg font-semibold text-foreground">页面加载失败</h1>
              <p className="mt-2 text-sm text-muted-foreground">
                {(error as Error).message || '请稍后重试'}
              </p>
              <button
                className="mt-4 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
                onClick={resetErrorBoundary}
              >
                重新加载
              </button>
            </div>
          </div>
        )}
      >
        <RoutesComponent />
        <Toaster />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

createRoot(document.getElementById("root")!).render(<MainApp />);
